export enum SpriteSheet {
  PLAYER = 'player',
  FRANKEN_ZAP = 'franken-zap',
  FRANKEN = 'franken',
  MESS = 'mess',
  TILESHEET = 'tilesheet',
  MUTE = 'mute',
  INFO = 'info',
  SHOPPER_1 = 'shooper 1',
  SHOPPER_2 = 'shooper 2',
  SHOPPER_3 = 'shooper 3',
  THEME = 'theme'
}
export enum AnimStates {
  LEFT = 'left',
  RIGHT = 'right',
  UP = 'up',
  DOWN = 'down',
  LEFT_WALK = 'left-walk',
  RIGHT_WALK = 'right-walk',
  UP_WALK = 'up-walk',
  DOWN_WALK = 'down-walk'
}

export enum AnimKeys {
  FRANKEN_LAY = 'lay',
  FRANKEN_ZAP = 'zap'
}

export enum CharKey {
  PLAYER = 'player',
  SHOPPER1 = 'shopper1',
  SHOPPER2 = 'shopper2',
  SHOPPER3 = 'shopper3',
  FRANKEN = 'franken'
}

export enum SceneKey {
  MENU = 'menu',
  GAME = 'game',
  HUD = 'hud'
}

export enum TileTypes {
  VERTSHELF = 'vertshelf',
  HORIZSHELF = 'horizshelf',
  STORAGESHELF = 'storageshelf',
  OPERATING_TABLE = 'operating',
  CHANGING_ROOM = 'changing room',
  FRONTDOOR = 'frontdoor',
  MANNEQUIN_STAND = 'mannequin stand',
  REGISTER = 'register'
}

export enum AudioKeys {
  THEME = 'theme',
  REGISTER = 'register',
  FRANK_VOICE_1 = 'frank 1',
  FRANK_VOICE_2 = 'frank 2',
  FRANK_VOICE_3 = 'frank 3',
  SHOPPER_DEATH = 'death',
  DOOR_1 = 'door 1',
  DOOR_2 = 'door 2',
  DOOR_3 = 'door 3',
  FRANK_ZAP_1 = 'zap 1',
  FRANK_ZAP_2 = 'zap 2',
  FRANK_ZAP_3 = 'zap 3'
}

export const gameBoyThemeKey = '?gameBoy'
export const mapKey = 'shop'
